export default "__VITE_ASSET__CWwiym1A__"